import React from 'react'
import { Link } from "react-router-dom"

import * as FileSaver from 'file-saver'

import App from '../App'
import Nav from './Nav'


class Home extends React.Component {

	state = {}


	// constructor(props) {
	// 	super(props)
	// }

	// componentDidUpdate() {
	// }


	loginWithTwitter = async () => {
		try {

			console.log('loginWithTwitter')
			var provider = new window.firebase.auth.TwitterAuthProvider()
			// window.firebase.auth().signInWithRedirect(provider)

			let result = await window.firebase.auth().signInWithPopup(provider)
			console.log(result, result.user, result.credential)
			await this.updateUserData(result)

		} catch (error) {
			console.error(error.message || error);
		}
	}
	updateUserData = async (result) => {
		let doc = App.currentUserDoc(result.user.uid)
		let snapshot = await doc.get()
		if (snapshot && snapshot.exists) {
			await App.currentUserDoc(result.user.uid).update({
				twitterUsername: result.additionalUserInfo.username,
				photoURL: result.user.photoURL,
			})
		}
		else {
			await App.currentUserDoc(result.user.uid).set({
				twitterUsername: result.additionalUserInfo.username,
				photoURL: result.user.photoURL,
				titleText: result.additionalUserInfo.username,
				descriptionText: 'Submit your email to get signed up for my mailing list!',
				referralText: "Share this link with others and you'll get credit for anyone who signs up from it.",
			})
		}
	}
	logout = async (event) => {
		event.preventDefault()
		await window.firebase.auth().signOut()
	}


	exportFollowers = async (event) => {
		event.preventDefault()
		// todo: loading indicator
		this.setState({ exporting: true })

		let followers = []
		let cursor = null
		while (true) {
			let query = window.firebase.firestore().collection('followers').where('uid', '==', this.props.appState.currentUser.uid).limit(1000)
			if (cursor) query = query.startAfter(cursor)
			let snapshot = await query.get()
			if (snapshot.docs.length === 0) break
			followers = followers.concat(snapshot.docs.map(doc => ({ ...doc.data(), _id: doc.id })))
			cursor = snapshot.docs[snapshot.docs.length - 1]
			// console.log(followers, cursor)
		}
		let emails = followers.map(f => f.followerEmail).filter((f, i, a) => !!f && a.indexOf(f) === i).join('\n')
		// console.log(emails)

		const blob = new Blob([emails], { type: 'text; charset=utf-8' })
		FileSaver.saveAs(blob, 'followers.txt')
		this.setState({ exporting: false })
	}


	render() {
		return (
			<div className="" >

				{this.props.appState.currentUser === undefined &&
					<div className="my-5 py-5 text-center"><div className="spinner-border"></div></div>
				}

				{this.props.appState.currentUser === null && this.renderGuest()}

				{this.props.appState.currentUserData && this.renderUser()}

			</div>
		)
	}

	renderGuest() {
		return (
			<>
				<div className="text-center my-5 py-3 py-md-5">
					<div className="h2  my-4">📩 Social Exporter</div>
					<div className="lead font-weight-normal opacity-50 ">Export Your Followers to Email</div>
					<div className="text-center mt-5 mb-4 ">
						<button className="btn btn-primary btn-twitter btn-lg px-5" onClick={this.loginWithTwitter}><i className="icon ion-logo-twitter mr-2"></i> Login with Twitter</button>
					</div>
				</div>

				<section className="bg-light py-1 py-md-5">
					<div className="container">
						<div className="row align-items-center my-4 my-md-5">
							<div className="col-md-6 h2 text-muted text-center pb-md-3 my-2">Get a link to export your followers</div>
							<div className="col-md-1"></div>
							<div className="col-md-5 my-2"><img src="/images/image1.png" className="img-fluid" /></div>
						</div>
						<div className="row align-items-center my-4 my-md-5">
							<div className="col-md-5 my-2"><img src="/images/image2.png" className="img-fluid" /></div>
							<div className="col-md-1"></div>
							<div className="col-md-6 h2 text-muted text-center pb-md-3 my-2 order-first order-md-last">Incentivize followers to refer others</div>
						</div>
						<div className="row align-items-center my-4 my-md-5">
							<div className="col-md-6 h2 text-muted text-center pb-md-3 my-2">Reward top referrers</div>
							<div className="col-md-1"></div>
							<div className="col-md-5 my-2"><img src="/images/image3.png" className="img-fluid" /></div>
						</div>
					</div>
				</section>

				<div className="text-center my-5 py-5">
					<div className="small text-muted mb-2">If you have any question or feedback, contact us at</div>
					<div className="h6"><a href="mailto:contact@socialexporter.com">contact@socialexporter.com</a></div>
				</div>

			</>
		)
	}

	renderUser() {
		return (
			<>
				<Nav {...this.props} ></Nav>
				<div className="d-flex align-items-center fullheight">
					<div className="container text-center my-5">

						{/* <div className="small text-uppercase text-muted">Logged in as</div> */}
						<div className="h6 my-2">
							<img className="profile-pic mr-2 rounded-circle" src={this.props.appState.currentUserData.photoURL} />
							{this.props.appState.currentUserData.titleText || this.props.appState.currentUserData.twitterUsername}
						</div>

						<div className="p-3 bg-light rounded my-4 max30">
							<div className="small text-uppercase text-muted ">Your public email sign up page</div>
							<div className="h5 my-2 overflow-auto">
								<Link to={'/' + this.props.appState.currentUserData.twitterUsername} target="_blank">{window.location.host + '/' + this.props.appState.currentUserData.twitterUsername}</Link>
							</div>
							<div className="small  opacity-50 ">This is where your followers can submit their email to get signed up for your mailing list.</div>
						</div>

						<div className="small font-weight-500 my-4">
							{!this.state.exporting && <a className="mx-2" href="#" onClick={this.exportFollowers}>Export Followers</a>}
							{this.state.exporting && <span className="mx-2 text-muted" >Exporting Followers <div class="spinner-border spinner-border-sm mx-1"></div></span>}
							<Link className=" mx-2" to={"/" + this.props.appState.currentUserData.twitterUsername + "/leaderboard"}>Leaderboard</Link>
							<Link className=" mx-2" to="/settings">Settings</Link>
							<a className="mx-2" href="#" onClick={this.logout}>Logout</a>
						</div>

					</div>
				</div>
			</>
		)
	}

}

export default Home
